import React from "react";

import { CategoryConnectionEdge } from "interfaces/wordpress";

const lexemes = {
  titleScreenReader: "Articles by Category",
  titleListScreenReader: " Articles",
  ctaTextScreenReader: "View more",
  ctaTextExtraScreenReader: " articles",
};

export type Props = {
  edge: CategoryConnectionEdge;
  navKey: number;
  activeIndex: number;
  onClick: () => void;
};

export default function CategoryTabsNavigationItem({
  edge,
  navKey,
  activeIndex,
  onClick,
}: Props) {
  const isActive = activeIndex === navKey;
  const id = navKey + 1;
  const node = edge?.node;

  return (
    <li className="nav-item tab-item" key={`nav-item-${navKey}`}>
      <button
        className={`nav-link  ${isActive ? "active" : ""}`}
        id={`cat${id}-tab`}
        onClick={() => onClick()}
        type="button"
        role="tab"
        aria-selected={isActive ? "true" : "false"}
        aria-controls={`cat${id}`}
        style={{
          backgroundColor: node.categoryPageFields?.categoryColor || undefined,
        }}
      >
        <h3 className="tab-title" id={`${id}-tab`}>
          {node?.name}
          <span className="screen-reader-text">
            {lexemes.titleListScreenReader}
          </span>
        </h3>
      </button>
    </li>
  );
}

export { CategoryTabsNavigationItem };
